export var DasAuthenticationStatus;
(function (DasAuthenticationStatus) {
    DasAuthenticationStatus["PENDING_INITIATION"] = "PENDING_INITIATION";
    DasAuthenticationStatus["INITIATED"] = "INITIATED";
    DasAuthenticationStatus["COMPLETE"] = "COMPLETE";
    DasAuthenticationStatus["CANCELLED"] = "CANCELLED";
    DasAuthenticationStatus["EXPIRED"] = "EXPIRED";
})(DasAuthenticationStatus || (DasAuthenticationStatus = {}));
